import { useAtomValue } from "jotai";
import { AIMContextViewAtom } from "../state/context.state";
import { DeltaLineagePanel } from "../panels/DeltaLineagePanel";
import { InvestmentCriteriaDrawer } from "./InvestmentCriteriaDrawer";
import { showInvestmentCriteriaDrawerAtom } from "../state";
import { LineagePanel } from "./LineagePanel";
import { FinanceLabMetricTable } from "./FinanceLabMetricTable";
import { AIMViewType } from "../InvestmentMemo.types";

export function AIMContextPanel() {
    const AIMContextView = useAtomValue(AIMContextViewAtom);
    const showInvestmentCriteriaDrawer = useAtomValue(
        showInvestmentCriteriaDrawerAtom,
    );

    if (AIMContextView?.type === AIMViewType.DELTA_LINEAGE) {
        return <DeltaLineagePanel {...AIMContextView.props} />;
    }

    if (showInvestmentCriteriaDrawer) {
        return <InvestmentCriteriaDrawer />;
    }

    if (AIMContextView?.type === AIMViewType.VALUE_LINEAGE) {
        return <LineagePanel {...AIMContextView} />;
    }

    if (AIMContextView?.type === AIMViewType.LABS_LINEAGE) {
        return <FinanceLabMetricTable {...AIMContextView} />;
    }

    return null;
}
